import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerModel, CustomerCase } from '@models/customer.model';
import { CustomerService } from '@modules/customers/customer.service';
import { LucideIconsModule } from '@shared/lucide-icons.module';
import { PayButtonComponent } from '@shared/components/UI-UX/pay-button/pay-button.component';

@Component({
  selector: 'app-send-reminder-modal',
  standalone: true,
  imports: [NgIf, TranslateModule, LucideIconsModule, PayButtonComponent],
  templateUrl: './send-reminder-modal.component.html',
  styleUrl: './send-reminder-modal.component.scss',
})
export class SendReminderModalComponent implements OnInit {
  customer: CustomerModel = {} as CustomerModel;
  customerCase: CustomerCase = {} as CustomerCase;
  sms: string = '';
  email: string = '';
  smsSelected = false;
  emailSelected = false;

  constructor(
    private customerService: CustomerService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    this.customerCase = this.config.data.customerCase;
    this.customerService.getCustomer((this.customerCase as any).customerId).then((res: any) => {
      this.customer = res;
      const { phones, emailAddresses } = this.customer;
      if (Array.isArray(phones) && phones.length > 0) this.sms = phones[0];
      if (Array.isArray(emailAddresses) && emailAddresses.length > 0) this.email = emailAddresses[0];
    });
  }

  get displayName(): string {
    return this.customer.longName || this.customer.name || '';
  }

  get caseRef(): string {
    return (this.customerCase as any).externalId || (this.customerCase as any).id || '';
  }

  get canSend(): boolean {
    return this.smsSelected || this.emailSelected;
  }

  toggleSms(): void { this.smsSelected = !this.smsSelected; }
  toggleEmail(): void { this.emailSelected = !this.emailSelected; }

  send(): void {
    this.ref.close({
      sms: this.smsSelected ? this.sms : '',
      email: this.emailSelected ? this.email : '',
      customerCase: this.customerCase,
      customer: this.customer,
    });
  }

  cancel(): void { this.ref.close(null); }
}
